import type { Context } from '../../../overmind';
import { routes } from '../../../overmind/machines/router';

export const handleHomeRoute = (context: Context) => ({
  [routes.root]: () => {
    if (context.state.calculation.calculationTactic.matches('LOADED')) {
      context.actions.calculation.unloadCalculation();
      context.actions.calculation.resetExternallyTriggeredCalculationSet();
    }
    if (context.state.selectedFeature.current) {
      context.actions.selectedFeature.unselectFeature();
    }
    context.actions.internal.setRoute({ route: 'root' });
  }
});
